import { useState } from "react";
import { loadLanguage } from "../lib/load-language";
import { Languages, LoaderCircle } from "lucide-react";
import { LANGUAGE_CONFIG, SUPPORTED_LANGUAGES, type Language } from "../lib/languages";
import { ui } from "../lib/localization";

export function LanguagePicker({ language, onChange, className = "" }: {
  language: Language; onChange: (language: Language) => void; className?: string;
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const change = async (next: Language) => {
    setLoading(true); setError(false);
    try { await loadLanguage(next); onChange(next); }
    catch { setError(true); }
    finally { setLoading(false); }
  };
  return <div className={`language-control ${className}`}>
    <label className="language-picker" aria-busy={loading}>
    {loading ? <LoaderCircle size={16} className="spinning" aria-hidden="true" /> : <Languages size={16} aria-hidden="true" />}
    <select value={language} disabled={loading} onChange={(event) => void change(event.target.value as Language)} aria-label={ui(language, "Language")}>
      {SUPPORTED_LANGUAGES.map((code) => <option key={code} value={code} lang={LANGUAGE_CONFIG[code].locale} dir={LANGUAGE_CONFIG[code].dir}>{LANGUAGE_CONFIG[code].name}</option>)}
    </select>
    </label>
    {error ? <span className="language-load-error" role="alert">{ui(language, "Could not load this language. Try again.")}</span> : null}
  </div>;
}
